import { NonauthenticatedComponent } from './nonauthenticated.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  HOME_COMPONENT_DECLARATIONS,
  HOME_COMPONENT_ENTRY_COMPONENTS,
  HOME_COMPONENT_IMPORTS,
} from './home/home.imports';

import {
  FEATURES_COMPONENT_DECLARATIONS,
  FEATURES_COMPONENT_ENTRY_COMPONENTS,
  FEATURES_COMPONENT_IMPORTS,
} from './features/features.imports';

import {
  PRICING_COMPONENT_DECLARATIONS,
  PRICING_COMPONENT_ENTRY_POINTS,
  PRICING_COMPONENT_IMPORTS,
} from './pricing/pricing.imports';

import { ENTERPRISE_DECLARATIONS } from './enterpise/enterprise.imports';
import { AboutComponent } from './about/about.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { FaqComponent } from './faq/faq.component';
import { PartnersComponent } from './partners/partners.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RegisterStepConfirmComponent } from './register/steps/register-step-confirm/register-step-confirm.component';
import { RegisterStepCreateComponent } from './register/steps/register-step-create/register-step-create.component';
import { RegisterStepPayComponent } from './register/steps/register-step-pay/register-step-pay.component';
import {
  RegisterStepPayProgressComponent,
} from './register/steps/register-step-pay-progress/register-step-pay-progress.component';
import { RegisterStepReceiptComponent } from './register/steps/register-step-receipt/register-step-receipt.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TermsComponent } from './terms/terms.component';
import { RegisterReferralComponent } from './register-referral/register-referral.component';
import { ReferralRegistrationThankYouComponent } from './referral-registration-thank-you/referral-registration-thank-you.component';
import { UnsubsComponent } from './unsubs/unsubs.component';
import { SpacescoutCallbackComponent } from './spacescout-callback/spacescout-callback.component';
import { GoogleCallbackComponent } from './google-callback/google-callback.component';

export const NONAUTHENTICATED_DECLARATIONS = [
  ...HOME_COMPONENT_DECLARATIONS,
  ...FEATURES_COMPONENT_DECLARATIONS,
  ...PRICING_COMPONENT_DECLARATIONS,
  ...ENTERPRISE_DECLARATIONS,
  NonauthenticatedComponent,
  AboutComponent,
  AnnouncementsComponent,
  HeaderComponent,
  FaqComponent,
  FooterComponent,
  PartnersComponent,
  ContactUsComponent,
  LoginComponent,
  RegisterComponent,
  RegisterStepCreateComponent,
  RegisterStepPayComponent,
  RegisterStepConfirmComponent,
  RegisterStepPayProgressComponent,
  RegisterStepReceiptComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  RegisterReferralComponent,
  ReferralRegistrationThankYouComponent,
  TermsComponent,
  UnsubsComponent,
  SpacescoutCallbackComponent,
  GoogleCallbackComponent,
];

export const NONAUTHENTICATED_IMPORTS = [
  ...HOME_COMPONENT_IMPORTS,
  ...FEATURES_COMPONENT_IMPORTS,
  ...PRICING_COMPONENT_IMPORTS,
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
];

export const NONAUTHENTICATED_ENTRY_COMPONENTS = [
  ...HOME_COMPONENT_ENTRY_COMPONENTS,
  ...FEATURES_COMPONENT_ENTRY_COMPONENTS,
  ...PRICING_COMPONENT_ENTRY_POINTS,
];
